module.exports = __webpack_public_path__ + "static/media/startpage2025.37caca70.png";